import { render, staticRenderFns } from "./CompBookStep5.vue?vue&type=template&id=07916e81&scoped=true"
import script from "./CompBookStep5.vue?vue&type=script&setup=true&lang=js"
export * from "./CompBookStep5.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07916e81",
  null
  
)

export default component.exports